const stageserviceId = "fsxlndcy";
const stagesecret = "exwnnrxk";
const productionserviceId = "fpfzhezd";
const productionsecret = "ymxdioxw";
const host = document.location.host;
const protocol = window.location.protocol;
const localBase = `${protocol}//${host}`;
const isLocal =
  host.includes('localhost') ||
  host.startsWith('127.') ||
  host.startsWith('10.') ||
  host.startsWith('192.168.');
const stagehost = 'stagetoolkit.i-scream.co.kr';
const productionhost = 'toolkit.i-scream.co.kr';
const testproductionhost = 'testtoolkit.i-scream.co.kr';

const local_callback_uri = `${localBase}/bridge.html?v=${__APP_VERSION__}`;
const stage_callback_uri = `https://stagetoolkit.i-scream.co.kr/bridge.html?v=${__APP_VERSION__}`;
const production_callback_uri = `https://toolkit.i-scream.co.kr/bridge.html?v=${__APP_VERSION__}`;
const testproduction_callback_uri = `https://testtoolkit.i-scream.co.kr/bridge.html?v=${__APP_VERSION__}`;

const local_login_url = `${localBase}/tlogin.html?v=${__APP_VERSION__}`;
const stage_login_url = `https://stagetoolkit.i-scream.co.kr/tlogin.html?v=${__APP_VERSION__}`;
const production_login_url = `https://toolkit.i-scream.co.kr/tlogin.html?v=${__APP_VERSION__}`;
const testproduction_login_url = `https://testtoolkit.i-scream.co.kr/tlogin.html?v=${__APP_VERSION__}`;

const local_logout_callback_uri = `${localBase}/`;
const stage_logout_callback_uri = 'https://stagetoolkit.i-scream.co.kr/';
const production_logout_callback_uri = 'https://toolkit.i-scream.co.kr/';
const testproduction_logout_callback_uri = 'https://testtoolkit.i-scream.co.kr/';

const callback_uri = `${localBase}/tlogin.html`;
const stageLoginCheckUrl = 'https://stageoauth2client.i-screammedia.com/loginCheck';
const productionLoginCheckUrl = 'https://oauth2client.i-screammedia.com/loginCheck';

const stageLoginUrl = 'https://stageoauth2client.i-screammedia.com/oauth2/authorization/iScream';
const productionLoginUrl = 'https://oauth2client.i-screammedia.com/oauth2/authorization/iScream';

const stageLogoutUrl = 'https://stageoauth2client.i-screammedia.com/user/logout';
const productionLogoutUrl = 'https://oauth2client.i-screammedia.com/user/logout';

const stageJoinUrl = 'https://stageaccount.i-screammedia.com/user/regUserSelect.do';
const productionJoinUrl = 'https://account.i-screammedia.com/user/regUserSelect.do';

const stageMyUrl = 'https://stageaccount.i-screammedia.com/user/modUserPwForm.do';
const productionMyUrl = 'https://account.i-screammedia.com/user/modUserPwForm.do';

const stageaccountapiUrl = 'https://stageaccount-api.i-screammedia.com/member/information_nickname';
const productionaccountapiUrl = 'https://account-api.i-screammedia.com/member/information_nickname';

let loginCheckUrl;
let loginUrl;
let logoutUrl;
let joinUrl;
let myUrl;
let accountapiUrl;

if(isLocal){
  loginCheckUrl = `${stageLoginCheckUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&callback_uri=${local_callback_uri}`;
  loginUrl = `${stageLoginUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${local_callback_uri}&loginUrl=${local_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  logoutUrl = `${stageLogoutUrl}?callback_uri=${local_logout_callback_uri}`;
  joinUrl = `${stageJoinUrl}?serviceId=${stageserviceId}&&callback_uri=${local_callback_uri}`;
  myUrl = `${stageMyUrl}?serviceId=${stageserviceId}&&callback_uri=${local_logout_callback_uri}`;
  accountapiUrl = `${stageaccountapiUrl}`;
}else if(host == stagehost){
  loginCheckUrl = `${stageLoginCheckUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&callback_uri=${stage_callback_uri}`;
  loginUrl = `${stageLoginUrl}?serviceId=${stageserviceId}&secret=${stagesecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${stage_callback_uri}&loginUrl=${stage_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  logoutUrl = `${stageLogoutUrl}?callback_uri=${stage_logout_callback_uri}`;
  joinUrl = `${stageJoinUrl}?serviceId=${stageserviceId}&&callback_uri=${stage_callback_uri}`;
  myUrl = `${stageMyUrl}?serviceId=${stageserviceId}&&callback_uri=${stage_logout_callback_uri}`;
  accountapiUrl = `${stageaccountapiUrl}`;
}else if(host == productionhost){
  loginCheckUrl = `${productionLoginCheckUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&callback_uri=${production_callback_uri}`;
  loginUrl = `${productionLoginUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${production_callback_uri}&loginUrl=${production_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  logoutUrl = `${productionLogoutUrl}?callback_uri=${production_logout_callback_uri}`;
  joinUrl = `${productionJoinUrl}?serviceId=${productionserviceId}&&callback_uri=${production_callback_uri}`;
  myUrl = `${productionMyUrl}?serviceId=${productionserviceId}&&callback_uri=${production_logout_callback_uri}`;
  accountapiUrl = `${productionaccountapiUrl}`;
}else if(host == testproductionhost){
  loginCheckUrl = `${productionLoginCheckUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&callback_uri=${testproduction_callback_uri}`;
  loginUrl = `${productionLoginUrl}?serviceId=${productionserviceId}&secret=${productionsecret}&lang=ko&mbtn=Y&ld=loginDirect&callback_uri=${testproduction_callback_uri}&loginUrl=${testproduction_login_url}&target=_blank&width=524&height=524`; //원래값은 680
  logoutUrl = `${productionLogoutUrl}?callback_uri=${testproduction_logout_callback_uri}`;
  joinUrl = `${productionJoinUrl}?serviceId=${productionserviceId}&&callback_uri=${testproduction_callback_uri}`;
  myUrl = `${productionMyUrl}?serviceId=${productionserviceId}&&callback_uri=${testproduction_logout_callback_uri}`;
  accountapiUrl = `${productionaccountapiUrl}`;
}

export { loginCheckUrl, loginUrl, logoutUrl, joinUrl, myUrl, accountapiUrl };